module.exports = __webpack_public_path__ + "static/media/Masquerain_gaussian2.c852b034.png";